import { render, staticRenderFns } from "./borrow-record.vue?vue&type=template&id=44bc4a80&scoped=true"
import script from "./borrow-record.vue?vue&type=script&lang=js"
export * from "./borrow-record.vue?vue&type=script&lang=js"
import style0 from "./borrow-record.vue?vue&type=style&index=0&id=44bc4a80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bc4a80",
  null
  
)

export default component.exports